import { createSelector } from "reselect";

import { getIsPauseHandled } from "./autoProfileSelector";

export const getSetupStore = (state) => state.setupStore;

export const getMainAlertMessage = createSelector(
  [getSetupStore],
  (setupStore) => ({
    alertShow: setupStore.alertShow,
    alertText: setupStore.alertText,
    alertStyle: setupStore.alertStyle,
  })
);

export const getFontSize = createSelector(
  [getSetupStore],
  (setupStore) => setupStore.fontSize
);

export const getRefillBufferPopup = createSelector(
  [getSetupStore, getIsPauseHandled],
  (setupStore, isPauseHandled) => {
    const {
      currentBuffer,
      // dialfiltrationStatus,
      refilledBufferVolume,
      isShowRefillBufferPopUp,
      profileRunning,
      transferVolume,
    } = setupStore;
    const { Config } = profileRunning;

    return {
      profileRunningConfig: Config,
      transferVolume,
      currentBuffer,
      // dialfiltrationStatus,
      refilledBufferVolume,
      isShowRefillBufferPopUp,
      isPauseHandled,
    };
  }
);

export const getCleaningProperties = createSelector(
  [getSetupStore],
  (setupStore) => setupStore.cleaningProperties
);

export const getCurrentAdvSetupParams = createSelector(
  [getSetupStore],
  (setupStore) => setupStore.currentAdvSetupParams
);
